import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SalesAccountHeadFormComponent } from './sales-account-head-form.component';
import { FormHandlerModule } from 'src/app/directives/form/form-handler.module';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    FormHandlerModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule
  ],
  declarations: [SalesAccountHeadFormComponent],
  exports: [SalesAccountHeadFormComponent]
})
export class SalesAccountHeadFormModule { }
